import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import BarsIcon from '@patternfly/react-icons/dist/js/icons/bars-icon';
import { Button, ButtonVariant } from '../../components/Button';
import { PageContextConsumer } from './Page';
export var PageHeader = function PageHeader(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$logo = _a.logo,
      logo = _a$logo === void 0 ? null : _a$logo,
      _a$logoProps = _a.logoProps,
      logoProps = _a$logoProps === void 0 ? null : _a$logoProps,
      _a$logoComponent = _a.logoComponent,
      logoComponent = _a$logoComponent === void 0 ? 'a' : _a$logoComponent,
      _a$headerTools = _a.headerTools,
      headerTools = _a$headerTools === void 0 ? null : _a$headerTools,
      _a$topNav = _a.topNav,
      topNav = _a$topNav === void 0 ? null : _a$topNav,
      _a$isNavOpen = _a.isNavOpen,
      isNavOpen = _a$isNavOpen === void 0 ? true : _a$isNavOpen,
      _a$role = _a.role,
      role = _a$role === void 0 ? undefined : _a$role,
      _a$showNavToggle = _a.showNavToggle,
      showNavToggle = _a$showNavToggle === void 0 ? false : _a$showNavToggle,
      _a$onNavToggle = _a.onNavToggle,
      onNavToggle = _a$onNavToggle === void 0 ? function () {
    return undefined;
  } : _a$onNavToggle,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Global navigation' : _a$ariaLabel,
      props = __rest(_a, ["className", "logo", "logoProps", "logoComponent", "headerTools", "topNav", "isNavOpen", "role", "showNavToggle", "onNavToggle", 'aria-label']);

  var LogoComponent = logoComponent;
  return React.createElement(PageContextConsumer, null, function (_ref) {
    var isManagedSidebar = _ref.isManagedSidebar,
        managedOnNavToggle = _ref.onNavToggle,
        managedIsNavOpen = _ref.isNavOpen;
    var navToggle = isManagedSidebar ? managedOnNavToggle : onNavToggle;
    var navOpen = isManagedSidebar ? managedIsNavOpen : isNavOpen;
    return React.createElement("header", Object.assign({
      role: role,
      className: css(styles.pageHeader, className)
    }, props), (showNavToggle || logo) && React.createElement("div", {
      className: css(styles.pageHeaderBrand)
    }, showNavToggle && React.createElement("div", {
      className: css(styles.pageHeaderBrandToggle)
    }, React.createElement(Button, {
      id: "nav-toggle",
      onClick: navToggle,
      "aria-label": ariaLabel,
      "aria-controls": "page-sidebar",
      "aria-expanded": navOpen ? 'true' : 'false',
      variant: ButtonVariant.plain
    }, React.createElement(BarsIcon, null))), logo && React.createElement(LogoComponent, Object.assign({
      className: css(styles.pageHeaderBrandLink)
    }, logoProps), logo)), topNav && React.createElement("div", {
      className: css(styles.pageHeaderNav)
    }, topNav), headerTools);
  });
};